// src/pages/CourseTime/components/slides/layouts/PledgeSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: PledgeTemplate
const PledgeSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  return (
    <S.PledgeLayout>
      <S.LeftContent>
        <S.SlideTitle>
          <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
        </S.SlideTitle>
        <S.PointText>{renderContent('content_0', slide.SlideContent)}</S.PointText>
      </S.LeftContent>

      <S.RightBox>
        <S.IconWrapper
          src={typeof slide.Images[0] === 'string' ? slide.Images[0] : slide.Images[0].url || ''}
          alt={`Slide ${slide.SlideOrder} image`}
        />
        <S.PledgeDescription>{renderContent('pledge_content', slide.SlidePledgeContent)}</S.PledgeDescription>
        <S.SubmitButton>I pledge</S.SubmitButton>
      </S.RightBox>
    </S.PledgeLayout>
  );
};

export default PledgeSlide;
